import "./bootstrap";
import "@vuepic/vue-datepicker/dist/main.css";
import "../css/app.css";
import "nprogress/nprogress.css";
import 'floating-vue/dist/style.css'

import { createPinia } from "pinia";
import FloatingVue from 'floating-vue'

import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy";
import * as Sentry from "@sentry/vue";
import Vapor from 'laravel-vapor';

const appName =
    window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";
const pinia = createPinia();

window.Vapor = Vapor;

Vapor.withBaseAssetUrl(import.meta.env.VITE_VAPOR_ASSET_URL)

createInertiaApp({
    title: (title) =>  {
        if(title.trim().length <= 0)
            return appName

        return `${title} - ${appName}`
    },
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob("./Pages/**/*.vue")
        ),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })

        Sentry.init({
            app,
            dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
            environment: import.meta.env.APP_ENV,
        });

        app
            .use(plugin)
            .use(ZiggyVue)
            .use(pinia)
            .use(FloatingVue)
            .mount(el);

        return app;
    },
    progress: {
        color: "#F86A24",
    },
});
